module.exports = __webpack_public_path__ + "static/media/ration.77f42782.jpg";